import { useQuery } from 'react-query';

import { queryKeys } from '../../../../../../utils/react-query';
import { ApiRequestError, getSearchBuilding } from '../../../../../../services/api';

import { AdvancedSearchFormData } from './types';

export const useSearchBuilding = (defaultValues: AdvancedSearchFormData, isSearchEnabled: boolean) => {
  const {
    error,
    isFetching: loading,
    data: searchResults,
    refetch
  } = useQuery<Awaited<ReturnType<typeof getSearchBuilding>>, ApiRequestError>(
    [queryKeys.advancedSearch, defaultValues],
    () => getSearchBuilding(defaultValues),
    {
      enabled: isSearchEnabled,
      keepPreviousData: true
    }
  );

  return {
    error,
    isLoading: loading,
    searchResults,
    refetch
  };
};
